module.exports = __webpack_public_path__ + "media/components/country-flag/static/mp-0d1781db75aecdd7f9b4fb870eb4ed74.svg";